// ============================================================
// DEALIN MVP - Home or Landing Router
// Show landing IMMEDIATELY for first paint, redirect once auth resolves.
// ============================================================

import { useAuth } from '@/hooks/useAuth';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { PageLoading } from '@/components/ui/Spinner';
import NewLandingPage from '@/pages/NewLanding';

const HomePage = lazy(() => import('@/pages/Home'));

export const HomeOrLanding = () => {
  const { isAuthenticated, isLoading, isVendor } = useAuth();

  // Show landing page immediately while auth is resolving
  // (most visitors are unauthenticated — no spinner needed)
  if (!isAuthenticated) {
    return <NewLandingPage />;
  }

  // Auth resolved → redirect authenticated users
  if (isVendor) {
    return <Navigate to="/manage?page=dashboard" replace />;
  }

  return (
    <Suspense fallback={<PageLoading />}>
      <HomePage />
    </Suspense>
  );
};

export default HomeOrLanding;
